import store from "@/store";

/**
 * @param {String} url
 * @param {Object} binds
 * @returns {*}
 */
export function bind(url, binds) {
  let newUrl = url;

  Object.entries(binds).map((values) => {
    newUrl = newUrl.replace(`{${values[0]}}`, values[1]);
  });

  return newUrl;
}

export const setInfluencerParametersInURL = (url) => {
  const storeLinks = store.getters["partner/getStoreLinks"];

  // Verifique se o getter retornou algo e é um array
  if (!Array.isArray(storeLinks) || storeLinks.length === 0) {
    return url;
  }

  // Pega o primeiro link do array
  const storeLink = storeLinks[0];

  const urlObj = new URL(url);

  // Extraia os parâmetros do link do getter e adicione à URL fornecida
  const linkParams = new URL(storeLink).searchParams;
  linkParams.forEach((value, key) => {
    urlObj.searchParams.set(key, value);
  });

  return urlObj.toString();
};

/**
 * Remove parâmetros duplicados de uma URL, mantendo apenas o último valor de cada chave.
 *
 * @param {string} url - A URL que será processada.
 * @returns {string} - A URL com os parâmetros duplicados removidos.
 */
export const cleanDuplicateParams = (url) => {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);

  const uniqueParams = {};

  // Itera sobre todos os pares de parâmetros
  for (const [key, value] of params.entries()) {
    uniqueParams[key] = value;
  }

  // Limpa todos os parâmetros existentes
  urlObj.search = "";

  // Adiciona os parâmetros únicos de volta
  const newParams = new URLSearchParams();
  for (const [key, value] of Object.entries(uniqueParams)) {
    newParams.append(key, value);
  }

  urlObj.search = newParams.toString();
  return urlObj.toString();
};
